import { NAV_PATHS } from '@modules/common/constants';
import { getTenantSlugFromURL } from '@modules/common/utils';
import {
  AnalysisUseCase,
  AssistantResponseTokenV2,
  EqlQuery,
  EqlQueryType,
} from 'generated/graphql';
import pluralize from 'pluralize';
import { getAnalysisLink } from 'v2/core/services/analysis/link';

export const getMarkdownForClipboardFromAssistantResponse = (
  tokenV2: AssistantResponseTokenV2,
  getQuantifyLink: (eql?: EqlQuery) => string | null,
) => {
  const markdownContent = tokenV2.text?.markdownContent;

  if (tokenV2.eql?.eql?.properties.type === EqlQueryType.Aggregates) {
    return `${window.location.origin}/${getTenantSlugFromURL()}/${
      NAV_PATHS.QUANTIFY
    }?${getQuantifyLink(tokenV2.eql?.eql)}`;
  }

  if (tokenV2.artefact) {
    const artefact = tokenV2.artefact;
    const feedbackCount = artefact.feedbackCount ?? 0;
    const recordString = pluralize('Record', feedbackCount, true);

    let artefactLink = getAnalysisLink({
      name: artefact.analysis?.title ?? '',
      token: artefact.analysis?.viewToken ?? '',
      tenantSlug: getTenantSlugFromURL(),
      useCase: artefact.analysis?.useCase ?? AnalysisUseCase.Default,
    });

    return ` [(${recordString})](${artefactLink})`;
  }

  if (tokenV2.text?.summaryDetails) {
    const { examples, label } = tokenV2.text.summaryDetails;

    const feedbackCount = examples?.count;

    if (label) {
      return `**${label?.details.displayName}**`;
    }

    if (examples?.labelExample?.recordIDs) {
      return `(${feedbackCount} Records)`;
    } else if (examples?.claimExample?.records) {
      return examples?.claimExample?.records
        .map(
          (claimExampleRecord, index) =>
            `[[${index + 1}]](${
              window.location.origin
            }/${getTenantSlugFromURL()}/record/${
              claimExampleRecord.recordID
            }?unfurl=false)`,
        )
        .join(', ')
        .trim();
    }

    return `${markdownContent}`;
  }

  return markdownContent ?? '';
};
